"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var mobx_react_1 = require("mobx-react");

var shared_1 = require("../../../shared");

var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));

var CalendarButton_1 = __importDefault(require("./styledComponents/CalendarButton"));

var ClickLayer_1 = __importDefault(require("./styledComponents/ClickLayer"));

var Calendar_1 = __importDefault(require("./styledComponents/Calendar"));

var Header_1 = __importDefault(require("./styledComponents/Header"));

var Body_1 = __importDefault(require("./styledComponents/Body"));

var HeaderNav_1 = __importDefault(require("./styledComponents/HeaderNav"));

var MonthButtonPrevious_1 = __importDefault(require("./styledComponents/MonthButtonPrevious"));

var MonthButtonNext_1 = __importDefault(require("./styledComponents/MonthButtonNext"));

var Month_1 = __importDefault(require("./styledComponents/Month"));

var Year_1 = __importDefault(require("./styledComponents/Year"));

var YearInput_1 = __importDefault(require("./styledComponents/YearInput"));

var Row_1 = __importDefault(require("./styledComponents/Row"));

var DayOfWeek_1 = __importDefault(require("./styledComponents/DayOfWeek"));

var DatePickerDay_1 = __importDefault(require("./styledComponents/DatePickerDay"));

var DatePickerDayPlaceholder_1 = __importDefault(require("./styledComponents/DatePickerDayPlaceholder"));

var DatePickerDaySelected_1 = __importDefault(require("./styledComponents/DatePickerDaySelected"));

var DatePickerDayDisabled_1 = __importDefault(require("./styledComponents/DatePickerDayDisabled"));

var DatePickerDayToday_1 = __importDefault(require("./styledComponents/DatePickerDayToday"));

var Icon_1 = __importDefault(require("../Icon"));

var ksys_app_template_1 = require("@kurtosys/ksys-app-template");

var moment = __importStar(require("moment"));

var CalendarInput_meta_1 = require("./CalendarInput.meta");

var mobx_1 = require("mobx");

var Translate_1 = __importDefault(require("../Translate"));

var Translate_2 = require("../Translate/Translate");

var CalendarInput =
/** @class */
function (_super) {
  __extends(CalendarInput, _super);

  function CalendarInput(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = CalendarInput_meta_1.CALENDAR_INPUT_CATEGORY_KEY;
    _this.componentKey = CalendarInput_meta_1.CALENDAR_INPUT_COMPONENT_KEY;

    _this.toggleCalendar = function (mustShow) {
      if (!_this.props.isFlat) {
        if (ksys_app_template_1.utils.typeChecks.isNullOrUndefined(mustShow)) {
          mustShow = !_this.showCalendar;
        }

        _this.showCalendar = mustShow;
      }
    };

    _this.showCalendar = !!props.isFlat;
    var uctValue = moment.utc(props.value);

    if (!_this.getDisabled(uctValue)) {
      _this.value = props.value ? uctValue.format('YYYY-MM-DD') : '';
      var calendarValue = moment.utc(_this.value || Date.now());
      _this.calendarMonth = parseInt(calendarValue.format('M'), 10);
      _this.calendarYear = parseInt(calendarValue.format('YYYY'), 10);
    } else {
      var calendarValue = moment.utc(Date.now());

      if (_this.getDisabled(calendarValue)) {
        calendarValue = moment.utc(_this.maximumDate);
      }

      _this.calendarMonth = parseInt(calendarValue.format('M'), 10);
      _this.calendarYear = parseInt(calendarValue.format('YYYY'), 10);
      _this.value = '';
    }

    return _this;
  }

  CalendarInput.prototype.componentDidUpdate = function (previousProps) {
    var value = this.props.value;

    if (value !== undefined && previousProps.value !== value) {
      this.value = value;
    }
  };

  Object.defineProperty(CalendarInput.prototype, "monthNames", {
    get: function get() {
      return this.props && this.props.monthNames || {
        jan: 'January',
        feb: 'February',
        mar: 'March',
        apr: 'April',
        may: 'May',
        jun: 'June',
        jul: 'July',
        aug: 'August',
        sep: 'September',
        oct: 'October',
        nov: 'November',
        dec: 'December'
      };
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CalendarInput.prototype, "formattedAllowedValues", {
    get: function get() {
      return (this.props.allowedValues || []).map(function (value) {
        return moment.utc(value).format('YYYY-MM-DD');
      });
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CalendarInput.prototype, "dayNames", {
    get: function get() {
      return this.props && this.props.dayNames || {
        sun: 'S',
        mon: 'M',
        tue: 'T',
        wed: 'W',
        thu: 'T',
        fri: 'F',
        sat: 'S'
      };
    },
    enumerable: true,
    configurable: true
  });

  CalendarInput.prototype.getValidDate = function (value) {
    var utcDate = moment.utc(value);
    var isDisabled = !value || !utcDate.isValid() || this.getDisabled(utcDate);

    if (isDisabled) {
      isDisabled = this.getDisabled(moment.utc());

      if (isDisabled) {
        if (ksys_app_template_1.utils.typeChecks.isNullOrEmpty(this.formattedAllowedValues)) {
          value = this.minimumDate;
        }
      } else {
        value = moment.utc().format('YYYY-MM-DD');
      }
    }

    return value;
  };

  CalendarInput.prototype.getMonthName = function (translationContext) {
    var _this = this;

    var failText = 'No Month Found';
    var _a = this.monthNames,
        jan = _a.jan,
        feb = _a.feb,
        mar = _a.mar,
        apr = _a.apr,
        may = _a.may,
        jun = _a.jun,
        jul = _a.jul,
        aug = _a.aug,
        sep = _a.sep,
        oct = _a.oct,
        nov = _a.nov,
        dec = _a.dec;
    var monthArray = [jan, feb, mar, apr, may, jun, jul, aug, sep, oct, nov, dec];
    var monthName = ksys_app_template_1.utils.object.safe(function () {
      return monthArray[_this.calendarMonth - 1];
    }, failText);
    return monthName && translationContext.translate(monthName);
  };

  CalendarInput.prototype.getCalendarDaysOfWeek = function (translationContext) {
    var _a = this.dayNames,
        sun = _a.sun,
        mon = _a.mon,
        tue = _a.tue,
        wed = _a.wed,
        thu = _a.thu,
        fri = _a.fri,
        sat = _a.sat;
    return [translationContext.translate(sun), translationContext.translate(mon), translationContext.translate(tue), translationContext.translate(wed), translationContext.translate(thu), translationContext.translate(fri), translationContext.translate(sat)];
  };

  CalendarInput.prototype.changeCalendarYear = function (year) {
    var utcValue = moment.utc(year + "-" + ksys_app_template_1.utils.formatter.padStart(this.calendarMonth, 2) + "-01");

    if (this.isInRange(utcValue, 'month')) {
      this.setState({
        calendarYear: year
      });
    }
  };

  CalendarInput.prototype.changeCalendarMonth = function (month) {
    var utcValue = moment.utc(this.calendarYear + "-" + ksys_app_template_1.utils.formatter.padStart(month, 2) + "-01");

    if (this.isInRange(utcValue, 'month')) {
      this.setState({
        calendarMonth: month
      });
    }
  };

  CalendarInput.prototype.moveCalendarMonth = function (increment) {
    if (increment !== 0) {
      var calendarMonth = this.calendarMonth;
      var calendarYear = this.calendarYear;
      calendarMonth += increment;

      if (calendarMonth <= 0) {
        var yearOffset = Math.trunc(calendarMonth / 12) - 1;
        calendarMonth = 12 - calendarMonth % 12;
        calendarYear += yearOffset;
      }

      if (calendarMonth > 12) {
        var yearOffset = Math.trunc(calendarMonth / 12);
        calendarMonth = calendarMonth % 12;
        calendarYear += yearOffset;
      }

      var utcValue = moment.utc(calendarYear + "-" + ksys_app_template_1.utils.formatter.padStart(calendarMonth, 2) + "-01");

      if (this.isInRange(utcValue, 'month')) {
        this.calendarMonth = calendarMonth;
        this.calendarYear = calendarYear;
      }
    }
  };

  Object.defineProperty(CalendarInput.prototype, "minimumDate", {
    get: function get() {
      var minimumDate = this.props.minimumDate;

      if (!ksys_app_template_1.utils.typeChecks.isNullOrEmpty(this.formattedAllowedValues)) {
        return this.formattedAllowedValues.reduce(function (a, b) {
          return new Date(a) < new Date(b) ? a : b;
        });
      }

      var workingMinimumDate = minimumDate || '1970-01-01';
      return workingMinimumDate;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CalendarInput.prototype, "maximumDate", {
    get: function get() {
      var maximumDate = this.props.maximumDate;

      if (!ksys_app_template_1.utils.typeChecks.isNullOrEmpty(this.formattedAllowedValues)) {
        return this.formattedAllowedValues.reduce(function (a, b) {
          return new Date(a) > new Date(b) ? a : b;
        });
      }

      var workingMaximumDate = maximumDate || '2099-01-01';
      return workingMaximumDate;
    },
    enumerable: true,
    configurable: true
  });

  CalendarInput.prototype.isInRange = function (date, granularity) {
    if (granularity === void 0) {
      granularity = 'day';
    }

    var min = this.minimumDate;
    var max = this.maximumDate;

    if (granularity === 'month') {
      min = moment.default(min).startOf('month');
      max = moment.default(max).endOf('month');
    }

    return date.isBetween(min, max);
  };

  CalendarInput.prototype.getDisabled = function (date) {
    if (!ksys_app_template_1.utils.typeChecks.isNullOrEmpty(this.formattedAllowedValues)) {
      return !this.formattedAllowedValues.includes(date.format('YYYY-MM-DD'));
    }

    return !this.isInRange(date);
  };

  CalendarInput.prototype.getCalendarRows = function () {
    var validDate = this.getValidDate(this.value);
    var rows = [];
    var utcValue = moment.utc(this.calendarYear + "-" + ksys_app_template_1.utils.formatter.padStart(this.calendarMonth, 2) + "-01");
    var firstDay = utcValue.startOf('month').format('YYYY-MM-DD');
    var lastDay = utcValue.endOf('month').format('YYYY-MM-DD');
    var today = this.getValidDate(moment.now().toString());
    var currentDay = moment.utc(firstDay);
    var currentRow = [];

    for (var i = 0; i < parseInt(moment.utc(firstDay).format('d'), 10); i++) {
      currentRow.push({
        isPlaceholder: true
      });
    }

    while (currentDay.isSameOrBefore(moment.utc(lastDay))) {
      if (currentRow.length === 7) {
        rows.push(currentRow);
        currentRow = [];
      }

      var date = currentDay.format('YYYY-MM-DD');
      currentRow.push({
        date: date,
        isPlaceholder: false,
        isSelected: date === validDate,
        isToday: date === today,
        disabled: this.getDisabled(currentDay)
      });
      currentDay = currentDay.add(1, 'day');
    }

    for (var i = parseInt(moment.utc(lastDay).format('d'), 10) + 1; i <= 6; i++) {
      currentRow.push({
        isPlaceholder: true
      });
    }

    rows.push(currentRow);
    return rows;
  };

  CalendarInput.prototype.handleDateChange = function (value) {
    var _a = this.props,
        onChange = _a.onChange,
        _b = _a.allowedValues,
        allowedValues = _b === void 0 ? [] : _b;

    if (value) {
      value = this.getValidDate(value);
      this.value = value;
      this.toggleCalendar(false);

      if (onChange) {
        if (allowedValues.length > 0) {
          var selectedValue = allowedValues.find(function (v) {
            var valueAsDate = moment.utc(v).format('YYYY-MM-DD');
            return value === valueAsDate;
          });
          onChange(selectedValue || '');
        } else {
          onChange(value);
        }
      }
    }
  };

  CalendarInput.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        className = _a.className,
        _b = _a.yearMode,
        headerYearMode = _b === void 0 ? 'flat' : _b;
    var calendarRows = this.getCalendarRows();
    return react_1.default.createElement(Wrapper_1.default, {
      className: className
    }, !this.props.isFlat && react_1.default.createElement(CalendarButton_1.default, {
      onClick: function onClick() {
        _this.toggleCalendar();
      }
    }, react_1.default.createElement(Icon_1.default, {
      asset: 'base.calendarInput.calendar'
    })), (this.props.isFlat || this.showCalendar) && react_1.default.createElement(Translate_2.TranslationContext.Consumer, null, function (translationContext) {
      return react_1.default.createElement(react_1.default.Fragment, null, !_this.props.isFlat && react_1.default.createElement(ClickLayer_1.default, {
        onClick: function onClick() {
          _this.toggleCalendar(false);
        }
      }), react_1.default.createElement(Calendar_1.default, null, react_1.default.createElement(Header_1.default, null, react_1.default.createElement(HeaderNav_1.default, null, react_1.default.createElement(MonthButtonPrevious_1.default, {
        onClick: function onClick() {
          return _this.moveCalendarMonth(-1);
        }
      }, react_1.default.createElement(Icon_1.default, {
        asset: 'base.calendarInput.previousMonth'
      })), react_1.default.createElement(Month_1.default, null, react_1.default.createElement(Translate_1.default, null, _this.getMonthName(translationContext))), headerYearMode === 'flat' && react_1.default.createElement(Year_1.default, null, _this.calendarYear), headerYearMode === 'input' && react_1.default.createElement(YearInput_1.default, {
        type: 'number',
        value: _this.calendarYear,
        onChange: function onChange(e) {
          var calendarYear = parseInt(e.target.value, 10);
          var utcValue = moment.utc(calendarYear + "-" + ksys_app_template_1.utils.formatter.padStart(_this.calendarMonth, 2) + "-01");

          if (_this.isInRange(utcValue, 'month')) {
            _this.calendarYear = calendarYear;
          }
        }
      }), react_1.default.createElement(MonthButtonNext_1.default, {
        onClick: function onClick() {
          return _this.moveCalendarMonth(1);
        }
      }, react_1.default.createElement(Icon_1.default, {
        asset: 'base.calendarInput.nextMonth'
      }))), react_1.default.createElement(Row_1.default, null, _this.getCalendarDaysOfWeek(translationContext).map(function (dayOfWeek, index) {
        return react_1.default.createElement(DayOfWeek_1.default, {
          key: dayOfWeek + "_" + index
        }, dayOfWeek);
      }))), react_1.default.createElement(Body_1.default, null, calendarRows.map(function (calendarRow, index) {
        return react_1.default.createElement(Row_1.default, {
          key: index
        }, calendarRow.map(function (datePickerDayProps, index) {
          var date = datePickerDayProps.date,
              isPlaceholder = datePickerDayProps.isPlaceholder,
              isSelected = datePickerDayProps.isSelected,
              disabled = datePickerDayProps.disabled,
              isToday = datePickerDayProps.isToday;
          var key = date + "_" + index;

          if (isPlaceholder) {
            return react_1.default.createElement(DatePickerDayPlaceholder_1.default, {
              key: key
            }, "\xA0");
          }

          var text = moment.utc(date).format('D');
          var Component = isSelected ? DatePickerDaySelected_1.default : disabled ? DatePickerDayDisabled_1.default : isToday ? DatePickerDayToday_1.default : DatePickerDay_1.default;
          var onClick = !disabled ? function () {
            _this.handleDateChange(date);
          } : function () {};
          return react_1.default.createElement(Component, {
            key: key,
            onClick: onClick
          }, text);
        }));
      }))));
    }));
  };

  __decorate([mobx_1.observable], CalendarInput.prototype, "showCalendar", void 0);

  __decorate([mobx_1.observable], CalendarInput.prototype, "calendarMonth", void 0);

  __decorate([mobx_1.observable], CalendarInput.prototype, "calendarYear", void 0);

  __decorate([mobx_1.observable], CalendarInput.prototype, "value", void 0);

  __decorate([mobx_1.computed], CalendarInput.prototype, "monthNames", null);

  __decorate([mobx_1.computed], CalendarInput.prototype, "formattedAllowedValues", null);

  __decorate([mobx_1.computed], CalendarInput.prototype, "dayNames", null);

  __decorate([mobx_1.computed], CalendarInput.prototype, "minimumDate", null);

  __decorate([mobx_1.computed], CalendarInput.prototype, "maximumDate", null);

  CalendarInput = __decorate([mobx_react_1.observer], CalendarInput);
  return CalendarInput;
}(shared_1.ComponentBase);

exports.CalendarInput = CalendarInput;
exports.default = shared_1.InjectedStyledComponent(CalendarInput, CalendarInput_meta_1.CALENDAR_INPUT_CATEGORY_KEY, CalendarInput_meta_1.CALENDAR_INPUT_COMPONENT_KEY);